var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rbvp-rules-editor" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-status-card rbvp-debug-context-card" }, [
      _c("div", { staticClass: "rbvp-status-card-label" }, [
        _vm._v("当前 Context"),
      ]),
      _vm._v(" "),
      _vm.state.debugContext
        ? _c("div", { staticClass: "rbvp-debug-context-grid" }, [
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("AID"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.aid || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "AID",
                        _vm.state.debugContext.video.aid,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("BVID"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.bvid || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "BVID",
                        _vm.state.debugContext.video.bvid,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("CID"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.cid || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "CID",
                        _vm.state.debugContext.video.cid,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("分 P"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.partIndex || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "分 P",
                        _vm.state.debugContext.video.partIndex,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("SECTION"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.sectionId || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "SECTION",
                        _vm.state.debugContext.video.sectionId,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("SECTION-ROOT"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(
                      _vm.state.debugContext.video.sectionRootId || "-"
                    ),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "SECTION-ROOT",
                        _vm.state.debugContext.video.sectionRootId,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("SECTION-ROOT-NAME"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(
                      _vm.state.debugContext.video.sectionRootName || "-"
                    ),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "SECTION-ROOT-NAME",
                        _vm.state.debugContext.video.sectionRootName,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("SECTION-NAME"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(
                      _vm.state.debugContext.video.sectionName || "-"
                    ),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "SECTION-NAME",
                        _vm.state.debugContext.video.sectionName,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("UP UID"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.upUid || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "UP UID",
                        _vm.state.debugContext.video.upUid,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("UP 名称"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.upName || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "UP 名称",
                        _vm.state.debugContext.video.upName,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("分区 ID"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(
                      _vm.state.debugContext.video.partitionId || "-"
                    ),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "分区 ID",
                        _vm.state.debugContext.video.partitionId,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("标题"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.title || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "标题",
                        _vm.state.debugContext.video.title,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("分 P 标题"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: String(_vm.state.debugContext.video.partTitle || "-"),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "分 P 标题",
                        _vm.state.debugContext.video.partTitle,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("时长"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  staticClass: "rbvp-context-readonly-input",
                  attrs: {
                    text: _vm.formatDuration(
                      _vm.state.debugContext.video.duration
                    ),
                    readonly: "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.selectAndCopyField(
                        "时长",
                        _vm.state.debugContext.video.duration,
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("标签"),
                ]),
                _vm._v(" "),
                _vm.state.debugContext.video.tags.length > 0
                  ? _c(
                      "div",
                      { staticClass: "rbvp-namespace-tags" },
                      _vm._l(_vm.displayTags, function (tag) {
                        return _c(
                          "span",
                          {
                            key: `context-tag-${tag.name}`,
                            staticClass:
                              "rbvp-namespace-tag rbvp-context-clickable-tag",
                            attrs: {
                              title: tag.isMusic
                                ? `单击复制 music_id: ${tag.musicId}`
                                : "单击复制标签",
                            },
                            on: {
                              click: function ($event) {
                                tag.isMusic
                                  ? _vm.copyMusicId(tag.name, tag.musicId)
                                  : _vm.copyTag(tag.name)
                              },
                            },
                          },
                          [
                            tag.isMusic
                              ? _c("VIcon", {
                                  staticClass: "rbvp-tag-music-icon",
                                  attrs: { icon: "mdi-music", size: 14 },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(tag.name) +
                                "\n          "
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "rbvp-field-hint" }, [
                      _vm._v("无"),
                    ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field rbvp-debug-context-span-2" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("本地规则集"),
                ]),
                _vm._v(" "),
                _vm.getDebugRuleSetEntries().length > 0
                  ? _c(
                      "div",
                      { staticClass: "rbvp-debug-rule-set-list" },
                      _vm._l(
                        _vm.getDebugRuleSetEntries(),
                        function ([name, ruleSet]) {
                          return _c(
                            "div",
                            {
                              key: `context-rule-set-${name}`,
                              staticClass: "rbvp-debug-rule-set-item",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "rbvp-debug-rule-set-name" },
                                [_vm._v(_vm._s(name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "rbvp-debug-rule-set-meta" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(ruleSet.matcherType) +
                                      " · " +
                                      _vm._s(ruleSet.entries.length) +
                                      " 项\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _c("div", { staticClass: "rbvp-field-hint" }, [
                      _vm._v("无本地规则集"),
                    ]),
              ]
            ),
          ])
        : _c("div", { staticClass: "rbvp-field-hint" }, [
            _vm._v("暂无 context 记录"),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-guide-card" }, [
      _c("div", { staticClass: "rbvp-guide-title" }, [_vm._v("上下文视图")]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-text" }, [
        _vm._v(
          "\n      这里会展示当前规则匹配使用的上下文信息，便于确认视频标识、合集信息、分区、标题和本地规则集是否符合预期。\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }